import { BaseConfig } from '../ServiceConfig';

export interface PosConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.PosServiceConfigData';
  url: string;
}

export const PosConfigurationFields: (keyof PosConfiguration)[] = ['url'];

export const BlankPosConfiguration: PosConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.PosServiceConfigData',
} as PosConfiguration;
